import axios from 'axios';
import { constants } from '@skunexus/utils';

const { API_PATH } = constants.CONFIG;

export function fetchDictionaries({ integrationId }) {
    const query = `
        query V1Queries {
            warehouse {
                grid(include_dropships: true, sort: {name: ASC}, limit: {size: 9999, page: 0}, filter: {status: {operator: eq, value: 1}}) {
                    rows {
                        value: id
                        label
                    }
                }
            }
            integration {
                magento2(id: "${integrationId}") {
                    msiSources {
                        value
                        label
                    }
                    websites {
                        value
                        label
                        code
                    }
                }
            }
        }
      `;

    return axios.post(`${API_PATH}/query`, { query });
}
